import styled from "styled-components";

export const PaginationContainer = styled.div`
  /* margin-left: 60px; */
  margin: 10px auto;
  background: transparent;
  width: fit-content;

  a {
    font-size: 36px;
  }
`;
